import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoColaboradoresEditarMigrarItemComponent {
  constructor () {
    this.step = 1
    this.item = null
    this.onSelect = null
  }

  seleccionar () {
    this.onSelect()
  }
}

module.component('fanProyectoColaboradoresEditarMigrarItem', {
  controller: FanProyectoColaboradoresEditarMigrarItemComponent,
  template,
  bindings: {
    proyectoId: '<',
    item: '<',
    destino: '<',
    onSelect: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/editar/migrar/item/component.js